const insertButton = () => {
  const mainMenu = document.getElementById('menu-main');
  const buttonMarkup =
    '<span class="submenu-trigger"><svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M26 26H2M26 26V2M26 26L2 2" stroke="currentColor" stroke-width="2.88"/></svg></span>';
  const listItems = mainMenu.querySelectorAll(
    '.menu-item.menu-item-has-children'
  );
  listItems.forEach((listItem) => {
    if (
      listItem.classList.contains('has-submenu-trigger') ||
      listItem.querySelector('button')
    )
      return;
    listItem.insertAdjacentHTML('afterbegin', buttonMarkup);
    listItem.classList.add('has-submenu-trigger');
  });
};

const openAccordion = (accordion, parent) => {
  const toggler = accordion.querySelector('.submenu-trigger');
  const content = accordion.querySelector('ul.sub-menu');
  const contentHeight = parseInt(content.scrollHeight + 16);
  toggler.classList.add('is-active');
  content.classList.add('is-active');
  content.style.maxHeight = contentHeight + 'px';
  parent.style.maxHeight =
    parseInt(parent.style.maxHeight) + contentHeight + 'px';
};

const closeAccordion = (accordion) => {
  const toggler = accordion.querySelector('.submenu-trigger');
  const content = accordion.querySelector('ul.sub-menu');
  toggler.classList.remove('is-active');
  content.classList.remove('is-active');
  content.style.maxHeight = 0;
};

const mobileMenuAccordion = () => {
  const mainMenu = document.getElementById('menu-main');
  const accordionItems = mainMenu.querySelectorAll(
    'li.menu-item-has-children.has-submenu-trigger'
  );
  accordionItems.forEach((accordion) => {
    const toggler = accordion.querySelector('.submenu-trigger');
    const content = accordion.querySelector('ul');
    const parent = accordion.parentElement;
    const closestItems = accordion
      .closest('ul')
      .querySelectorAll('li.menu-item-has-children.has-submenu-trigger');

    toggler.onclick = () => {
      if (content.classList.contains('is-active')) {
        closeAccordion(accordion);
      } else {
        closestItems.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion, parent);
      }
    };
  });
};

window.onload = function () {
  insertButton();
  mobileMenuAccordion();
};

jQuery(window).on('resize', function () {
  $('.hamburger--elastic').removeClass('is-active');
  $('body').removeClass('lock');
  $('.js-mobile-menu-widget').fadeOut();
  $('.mobile-menu-button').fadeOut();
});
